export default class WellItem {
  constructor(row, column, rowTipCount, columnTipCount) {
    this.row = row || '';
    this.column = column || '';
    this.rowTipCount = rowTipCount;
    this.columnTipCount = columnTipCount;
  }
}
